import { NgModule } from '@angular/core';
import { PaymentSlipsRoutingModule } from './payment-slips-routing.module';
import { PaymentSlipsComponent } from './payment-slips.component';
import { SharedModule } from '../shared/shared.module';
import { RegistroModalComponent } from './components/registro-modal/registro-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { EditModalComponent } from './components/edit-modal/edit-modal.component';
import { DialogService } from 'primeng/dynamicdialog';
import { CalendarModule } from 'primeng/calendar';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DetailModalComponent } from './components/detail-modal/detail-modal.component';
import { BulkLoadComponent } from './components/bulk-load/bulk-load.component';
import { DividerModule } from 'primeng/divider';
import { PaymentValidateModalComponent } from './components/payment-validate/payment-validate-modal.component';
import { ErrorDetailsModalComponent } from './components/error-details-modal/error-details-modal.component';

@NgModule({
  declarations: [
    PaymentSlipsComponent,
    RegistroModalComponent,
    EditModalComponent,
    DetailModalComponent,
    BulkLoadComponent,
    ErrorDetailsModalComponent,
    PaymentValidateModalComponent
  ],
  imports: [
    PaymentSlipsRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    CalendarModule,
    InputSwitchModule,
    DividerModule
    ],
  providers: [
    DialogService,
  ]
})
export class PaymentSlipsModule {}
